window.$ = window.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new bootstrap.Tooltip(tooltipTriggerEl)
})

//TARGET _BLANK ----------------------------------------------------------------
var url = $('meta[name=landing]').attr("content");
$('a[href^="http"], a[href^="https"]').not("[href^='" + url + "']").attr("target", "_blank").attr("rel", "noopener dofollow");

//CLASS ACTIVE NAV -------------------------------------------------------------
var url = (location.pathname == "/") ? "" : location.pathname;
$('.navbar-nav a[href="' + location.origin + url + '"]').addClass('active');

//BURGER NAVBAR ----------------------------------------------------------------
$('#navbar').on('show.bs.collapse', function () { $('.burger').addClass('active'); });
$('#navbar').on('hide.bs.collapse', function () { $('.burger').removeClass('active'); });

// BOOTSTRAP 5 FORM --------------------------------------------------------------------------
$("select.form-control").addClass('form-select');

document.addEventListener('DOMContentLoaded', (event) => {
	//HEIGHT FOOTER + NAVBAR------------------------------------------------------------------
	setTimeout(function () {
		$(':root').css('--navHeight', $('nav').outerHeight()+"px");
		$('.wrapper').css("margin-bottom", $('footer').outerHeight() + "px");
	}, 500);
	$(window).on('resize', function () {
		$(':root').css('--navHeight', $('nav').outerHeight()+"px");
		$('.wrapper').css("margin-bottom", $('footer').outerHeight() + "px");
	});
 })

$(document).on('scroll', function () {
	if (window.matchMedia("(min-width: 575.98px)").matches) {
		if ($(this).scrollTop() != 0){
			$('.navbar .navbar-brand img').css('height', "60px");
			$('.navbar .navbar-brand h2, .navbar .navbar-brand .h2').css('font-size', "1.2rem");
		}else{
			$('.navbar .navbar-brand img').css('height', "80px");
			$('.navbar .navbar-brand h2, .navbar .navbar-brand .h2').css('font-size', "1.8rem");
		}
	}
});
